export const PANEL_CLASSES = "bg-white rounded-lg border border-divider-lines overflow-hidden flex flex-col";

export const HEADER_CLASSES = "px-3.5 py-2.5 font-semibold text-sm text-off-black border-b border-divider-lines bg-very-light-gray flex justify-between items-center";

export const SECTION_LABEL = "text-[12px] font-bold text-medium-gray uppercase tracking-wide mb-2";

const MAPPING_DISPLAY_BASE = "rounded-md px-2.5 py-1 font-mono text-xs flex items-center gap-1.5 flex-1 min-h-[28px] border";

// Valid mapping (path found in schema): subtle — dark-gray border + black text, no fill — to reduce color noise.
export const MAPPING_DISPLAY = `${MAPPING_DISPLAY_BASE} border-secondary-gray text-off-black`;

// Invalid mapping (path not in schema): kept prominent with a yellow fill so it stands out as a warning.
export const MAPPING_DISPLAY_WARNING = `${MAPPING_DISPLAY_BASE} bg-warning-yellow border-warning-yellow text-warning-dark-yellow`;

export const DROP_ZONE = "flex-1 border-2 border-dashed rounded-md px-3 py-1.5 min-h-[28px] text-xs text-center transition-all";

export const DROP_ZONE_ACTIVE = "border-dark-green bg-light-green text-dark-green";

export const DROP_ZONE_IDLE = "border-field-outline text-medium-gray";

// Empty drop zones while a source leaf is armed for click-mapping — signals "click me".
export const DROP_ZONE_TARGET_HOT = "border-dark-green text-dark-green animate-pulse cursor-pointer";

export const LOCKED_FIELD = "bg-very-light-gray rounded-md px-2.5 py-1 font-mono text-xs text-medium-gray flex items-center gap-1.5 flex-1 min-h-[28px] border border-field-outline";

// ── Per-field transforms ──
// Purple is the accent for everything transform-related (wand, pills, transformed preview),
// so the feature reads as one distinct system against the green/blue mapping UI.

// Small wand button inside a mapping chip that opens the transform picker.
export const TRANSFORM_ADD_BTN = "text-purple hover:text-dark-purple leading-none px-1 py-0.5 rounded shrink-0";
export const TRANSFORM_ADD_BTN_ACTIVE = "text-dark-purple bg-light-purple leading-none px-1 py-0.5 rounded shrink-0";
// Shown (not hidden) when the filter is complex, so the feature stays discoverable —
// paired with a tooltip explaining why it's unavailable.
export const TRANSFORM_ADD_BTN_DISABLED = "text-ui-disabled cursor-not-allowed leading-none px-1 py-0.5 rounded shrink-0 inline-flex";

// A single applied-transform pill shown beneath a mapping chip
// (icon + monospace summary + subtle ×).
export const TRANSFORM_PILL = "inline-flex items-center gap-1.5 font-mono text-[11px] bg-light-purple text-dark-purple rounded-full px-2.5 py-0.5";

// Transformed value shown after the pills (`= 2024-06-26T…`).
export const TRANSFORM_PREVIEW = "text-dark-purple text-[11px] max-w-[160px] overflow-hidden text-ellipsis whitespace-nowrap";

// Portaled grouped picker popover.
export const TRANSFORM_MENU = "bg-white border border-divider-lines rounded shadow-lg overflow-hidden py-1";
export const TRANSFORM_MENU_SECTION = "text-[10px] font-bold text-medium-gray uppercase tracking-wide px-3 pt-2 pb-1";
export const TRANSFORM_MENU_ITEM = "w-full flex items-center justify-between gap-3 px-3 py-1.5 text-xs text-left text-off-black transition-colors focus:outline-none hover:bg-light-purple";
